import { getUpgradeCurrentReplaceValueById } from "@/game/utils/upgrades";
import useUpgradesStore from "@/store/useUpgradesStore";
import { EventCategory } from "@/types/ui";
import { FrameName } from "../config";
import { ResourceType } from "../config/resources";
import { EventUpgradeIds } from "../config/upgrades/";
import EventTileEntity from "../EventTileEntity";

class DarkwoodLumberMillBuildingTileEntity extends EventTileEntity {
	public static readonly eventType = EventCategory.CHRISTMAS;

	public static readonly frameName = FrameName.DARKWOOD_LUMBER_MILL;

	public get range(): number | null {
		if (!super.range) return null;
		return (
			super.range +
			getUpgradeCurrentReplaceValueById(
				EventUpgradeIds.ch_beasts_of_burden,
			)
		);
	}

	public get requirements(): Map<ResourceType, number> {
		const requirements = new Map<ResourceType, number>(super.requirements);

		// Apply upgrades
		let connectionRequirement =
			(requirements.get(ResourceType.SETTLEMENT_CONNECTION) as number) ||
			0;
		if (
			useUpgradesStore().getCurrentLevelById(
				EventUpgradeIds.ch_log_driving,
			) > 0
		) {
			connectionRequirement = 0;
		}
		requirements.set(
			ResourceType.SETTLEMENT_CONNECTION,
			connectionRequirement,
		);

		return requirements;
	}
}

export default DarkwoodLumberMillBuildingTileEntity;
